<template>
    <div
        class="form-input"
        :class="[{
            filled: isFilled,
            focus: focus,
            valid: valid === true,
            invalid: valid === false
        }, typeClass]"
    >
        <label v-if="label" :for="name" v-text="label" class="form-input-label" />

        <input
            v-if="mask !== null"
            :id="name"
            :title="label"
            :name="name"
            :value="value"
            :disabled="disabled"
            :type="type"
            v-mask="mask"
            @focus="onFocus"
            @blur="onBlur"
            @input="$emit('input', $event.target.value)"
        />
        <input
            v-else
            :id="name"
            :title="label"
            :name="name"
            :value="value"
            :disabled="disabled"
            :type="type"
            @focus="onFocus"
            @blur="onBlur"
            @input="$emit('input', $event.target.value)"
        />
    </div>
</template>

<script>
    import {mask} from 'vue-the-mask'
    export default {
        name: "FormInput",
        directives: {mask},
        props: {
            name: {
                type: String,
                required: true
            },
            label: {
                type: [String, Boolean],
                default: false
            },
            value: {
                type: String,
                default: ""
            },
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            valid: {
                type: Boolean,
                default: null
            },
            max: {
                type: Number,
                default: 250
            },
            type: {
                type: String,
                default: 'text'
            },
            mask: {
                type: String,
                default: null
            }
        },
        data () {
            return {
                focus: false,
            }
        },
        computed: {
            isFilled () {
                return this.focus || this.value
            },
            typeClass () {
                return `form-input--${this.type}`
            }
        },
        methods: {
            onFocus (e) {
                this.focus = true
                this.$emit('focus', e)
            },
            onBlur (e) {
                this.focus = false
                this.$emit('blur', e)
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/color';
    @import 'src/assets/scss/_variables/fonts';
    @import 'src/assets/scss/_variables/mixin';

    .form-input {
        margin: 0 0 20px;
        position: relative;

        &-label {
            font-size: 1.6rem;
            display: inline-block;
            margin-bottom: 6px;
            cursor:pointer;
        }

        input {
            width: 100%;
            border: 1px solid $color-border;
            border-radius: 4px;
            font-size: 2rem;
            line-height: 1.2;
            font-weight: $font-weight-normal;
            color: $color-default;
            padding: 0.85em 1em;
            outline: none;


        }

        &.focus {
            input {
                border-color: $color-primary;
            }
        }
        &.invalid {
            input {
                border-color: $color-error;
            }
        }
        &.valid {
            input {
                border-color: $color-positive;
            }
            &:after {
                content: '';
                position: absolute;
                right: 14px;
                bottom: 16px;

                background-image: url("~@/assets/images/success-icon.png");
                background-size: 98%;
                background-repeat: no-repeat;
                @include size(26px)
            }
        }

        &--tel {
            input {
                padding-left: 3em;


            }
            &:after {
                content: '+48';
                position :absolute;
                bottom: 1em;
                left: 1em;
                pointer-events: none;
                opacity: .5;
                font-size: 2rem;
                line-height: 1.2;
                font-weight: $font-weight-normal;
                color: $color-default;
            }
        }
    }
</style>
